import clsx from "clsx";

import classes from "./styles.module.scss";

import type { IAppointmentCardProps } from "@components/organisms/appointmentCard";
import { AppointmentCardBottom } from "@components/organisms/appointmentCard/components/appointmentCardBottom";
import { AppointmentCardTop } from "@components/organisms/appointmentCard/components/appointmentCardTop";
import { AppointmentCardActions } from "@components/organisms/appointmentCard/components/appointmentCardActions";
import { CardContainer } from "@components/molecules/cardContainer";
import { Separator } from "@components/atoms/separator/separator";

/**
 * AppointmentCard component displays an appointment card with its top and bottom sections.
 *
 * @param {IAppointmentCardProps} props - The props for the AppointmentCard component.
 * @param {TAppointmentStatus} props.status - The status of the appointment.
 * @param {IAppointmentCardTopProps} props.data - Data for rendering the top section of the appointment card.
 * @returns AppointmentCard The rendered AppointmentCard component.
 */
export function AppointmentCard({
  data,
  actions,
  status,
  variant,
  ...rest
}: IAppointmentCardProps) {
  return (
    <CardContainer boxProps={{ radius: "lg", px: "0", py: "0" }}>
      <div className={clsx(classes.appointmentCard)}>
        {/* Display actions for the appointment card */}
        <AppointmentCardActions
          {...actions}
          id={rest.id}
          canJoin={rest?.canJoin}
          variant={variant}
        />
        {/* Display the top section of the appointment card */}
        <AppointmentCardTop {...data} />
        {/* Display a separator */}
        <Separator />
        {/* Display the bottom section of the appointment card */}
        <AppointmentCardBottom
          status={status}
          {...rest}
          variant={variant}
          {...actions}
          noShowCause={rest.noShowCause}
        />
      </div>
    </CardContainer>
  );
}
